angular.module('services.algoliaResource',
    ['security.service', 'config']).factory('algoliaResource', ['$http', '$q', '$log', 'security', function ($http, $q) {
    // local variable

    const NEXTJS_URL = 'https://iworis-family.pl'
    //const NEXTJS_URL = 'http://localhost:3000'
    var baseUrl = `${NEXTJS_URL}/api`;
    var processResponse = function(res){
      return res.data;
    };
    var processError = function(e){
      var msg = [];
      if(e.status)         { msg.push(e.status); }
      if(e.statusText)     { msg.push(e.statusText); }
      if(msg.length === 0) { msg.push('Unknown Server Error'); }
      return $q.reject(msg.join(' '));
    };
    // public api
    var resource = {};
    resource.indexingArticles = function(){
      return $http.get(baseUrl + '/algolia/articles').then(processResponse, processError);
    };
    resource.indexingAuthors = function(){
      return $http.get(baseUrl + '/algolia/authors', ).then(processResponse, processError);
    };
    resource.indexingTags = function(){
      return $http.get(baseUrl + '/algolia/tags', ).then(processResponse, processError);
    };
  
    return resource;
  }]);
  


// WEBPACK FOOTER //
// ./client/src/common/services/algoliaResource.js